import _ from 'lodash'
import { action, computed, makeObservable, observable } from 'mobx'
import { VesselTallyViewStore } from './VesselTallyViewStore'

export class SearchContainerViewStore {
  selectedOrderId?: number
  searchFilter = ''

  constructor(public parentStore: VesselTallyViewStore) {
    makeObservable(this, {
      selectedOrderId: observable,
      searchFilter: observable,
      selectedOrder: computed,
      filteredOrders: computed,
      isSearchFilterValid: computed,
      selectOrder: action,
      setSearchFilter: action,
    })
  }

  get selectedOrder() {
    return _(this.parentStore.orders).find(vv => vv.id === this.selectedOrderId)
  }

  get filteredOrders() {
    if (!this.isSearchFilterValid) return []

    const result = this.parentStore.orders?.filter(
      o =>
        o.data.status === 'Open' &&
        o.data.containerNumber?.toUpperCase().includes(this.searchFilter),
    )

    result?.forEach(o => {
      const assignedCrane = this.parentStore.assignedCraneForOrder?.find(a => a.orderId === o.id)

      o.setCrane?.(assignedCrane, this.parentStore.selectedCrane?.id)
    })

    return result
  }

  get isSearchFilterValid() {
    return this.searchFilter.length >= 5
  }

  public getOutboundStowagePositionForRestow(containerNumber: string) {
    const order = this.parentStore.selectedVisit?.restow.loadOrders.find(
      o => o.data.containerNumber === containerNumber,
    )
    return order?.data.stowagePosition
  }

  selectOrder = (id?: number) => {
    this.selectedOrderId = id
  }

  setSearchFilter = (filter: string) => {
    this.searchFilter = filter.toUpperCase()
  }
}
